"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaLogo = exports.logoSvg = exports.innerLogo = exports.bannerLink = exports.bannerInner = exports.banner = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var banner = /*#__PURE__*/(0, _core.css)("background-color:", _feBrary.variables.colour.neutral100, ";", (0, _feBrary.media)('<desktop'), "{display:none;}");
exports.banner = banner;
var bannerInner = isFullWidth => /*#__PURE__*/(0, _core.css)("display:flex;align-items:center;padding:0 ", _feBrary.variables.global.gutterSpacing.desktop, ";height:24px;max-width:", isFullWidth ? '100%' : '1280px', ";margin:0 auto;");
exports.bannerInner = bannerInner;
var mediaLogo = /*#__PURE__*/(0, _core.css)("display:flex;align-items:center;align-self:stretch;padding-right:8px;margin-right:8px;border-right:1px solid ", _feBrary.variables.colour.neutral300, ";");
exports.mediaLogo = mediaLogo;
var innerLogo = {
  name: "1xvzo5j",
  styles: "width:81px;height:18px;"
};
exports.innerLogo = innerLogo;
var logoSvg = /*#__PURE__*/(0, _core.css)("fill:", _feBrary.variables.colour.neutral500, ";");
exports.logoSvg = logoSvg;
var bannerLink = /*#__PURE__*/(0, _core.css)(_feBrary.aNormalize, " color:", _feBrary.variables.colour.neutral500, ";font-size:", _feBrary.variables.font.xsmallFontSize, ";line-height:", _feBrary.variables.font.xsmallLineHeight, ";&:visited{color:", _feBrary.variables.colour.neutral500, ";}&:not(:last-child)::after{content:'|';margin:0 3px;}");
exports.bannerLink = bannerLink;